// Static site config: brand assets, imagery and navigation structure.
// Text labels are resolved through the translation layer (i18nKey).
// Stock imagery is self-hosted locally (bundled at build time) — no external
// requests to images.unsplash.com. Source/licence inventory kept internally
// (standard Unsplash License; commercial use + self-hosting permitted).
import viennaHero from '../assets/stock/vienna-hero.jpg';
import powderPile from '../assets/stock/powder-pile.jpg';
import powderScoop from '../assets/stock/powder-scoop.jpg';
import powderMagnifier from '../assets/stock/powder-magnifier.jpg';
import powderBeige from '../assets/stock/powder-beige.jpg';
import labTest1 from '../assets/stock/lab-test-1.jpg';
import labTest2 from '../assets/stock/lab-test-2.jpg';
import concreteArch1 from '../assets/stock/concrete-arch-1.jpg';
import concreteArch2 from '../assets/stock/concrete-arch-2.jpg';

export const ASSETS = {
  logo: 'https://customer-assets.emergentagent.com/job_newchem-blue/artifacts/6ym5iao2_newchem_gmbh.png',
  viennaHero,
  powderPile,
  powderScoop,
  powderMagnifier,
  powderBeige,
  labTest1,
  labTest2,
  concreteArch1,
  concreteArch2,
};

// Main header navigation (scientific IA). label resolved via t('nav.<key>')
export const NAV = [
  { key: 'grundlagen', path: '/grundlagen' },
  { key: 'reaktion', path: '/reaktion' },
  { key: 'qualitaet', path: '/qualitaet-pruefung' },
  { key: 'eigenschaften', path: '/eigenschaften' },
  { key: 'zementsubstitution', path: '/zementsubstitution' },
  { key: 'anwendungen', path: '/anwendungen' },
  { key: 'wissen', path: '/wissen' },
  { key: 'kompetenz', path: '/newchem-kompetenz' },
];

// Secondary links (footer only).
export const FOOTER_NAV = [
  { key: 'ueber', path: '/ueber-metakaolin-info' },
  { key: 'fachredaktion', path: '/fachredaktion' },
  { key: 'downloads', path: '/downloads' },
  { key: 'cases', path: '/case-studies' },
  { key: 'links', path: '/external-links' },
];

// Legal links shown prominently in the footer bottom bar.
export const FOOTER_LEGAL = [
  { key: 'impressum', path: '/impressum' },
  { key: 'datenschutz', path: '/datenschutz' },
  { key: 'disclaimer', path: '/disclaimer' },
];

// Base path for the specific-feature detail pages.
export const FEATURE_BASE = '/eigenschaften';

export const SITE_URL = 'https://www.metakaolin.info';

// Slugs for the 13 specific-feature detail pages. Order MUST match
// translations.features.list order in both languages.
export const FEATURE_SLUGS = [
  'pore-size',
  'durability',
  'adhesion-strength',
  'water-retention',
  'asr-reduction',
  'sulphate-resistance',
  'efflorescence',
  'chloride-migration',
  'lighter-colour',
  'freeze-thaw',
  'acid-resistance',
  'co2-reduction',
  'setting-time',
];

export const CONTACT = {
  company: 'Newchem GmbH',
  street: 'Flamminggasse 79',
  city: '2500 Baden bei Wien',
  country: 'Austria',
  email: 'office@newchem.org',
  phone: '+43 2252 45 970',
  website: 'https://www.newchem.info',
  metakaolinEmail: 'office@newchem.org',
};
